var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link-guard',{attrs:{"to":{ name: _vm.name, params: { id: _vm.id } },"target":_vm.target,"can":_vm.can}},[_vm._t("default",[_c('v-btn',{attrs:{"elevation":"0","small":""}},[_vm._v(" "+_vm._s(_vm.display || _vm.id)+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }